import { translate, type Translation } from "./lang.ts";
import { workshopEn } from "./workshop.en.ts";

/**
 * Xưởng Phép Thuật copy (Magic Workshop, "Lụa Phép"). Same house
 * style as vi.ts: warm and plain, no dashes, dots, slashes, symbols or
 * parentheses. English twin in `workshop.en.ts`.
 */
const source = {
  rolls: (n: number) => `${n} cuộn`,
  hintCost: "Xài gợi ý thì màn này tối đa 2 sao thôi đó. Vẫn xài hông?",
  stuck: "Cuộn trên kệ không đủ phủ chỗ còn hở rồi. Hoàn tác vài cuộn thử nha!",
  resultRolls: (n: number, best: number) =>
    n <= best ? `Bạn gói bằng ${n} cuộn, gọn y như lời giải đẹp nhất!` : `Bạn gói bằng ${n} cuộn, lời giải gọn nhất chỉ cần ${best} cuộn.`,
  resultRule: (three: number, two: number) => `Ba sao khi dùng không quá ${three} cuộn, hai sao khi không quá ${two} cuộn.`,
  resultHint: "Có xài gợi ý nên tối đa 2 sao nha.",
  shelf: (n: number) => `Còn ${n} cuộn`,
};

export type WorkshopStrings = Translation<typeof source>;

export const workshopVi: WorkshopStrings = translate(source, workshopEn);
